import { Injectable } from '@angular/core';
import {
  Resolve,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { EMPTY, map, mergeMap, Observable, of } from 'rxjs';
import { Staff } from '@app/models/staff.model';
import { AuthSelectors } from '@app/store/auth/auth.selectors';
import { SetStaffList } from '@app/store/data/data.classes';
import { DataSelectors } from '@app/store/data/data.selectors';

@Injectable({
  providedIn: 'root',
})
export class StaffListResolverService implements Resolve<Staff[]> {
  constructor(private store: Store) { }
  resolve(): Observable<Staff[]> {
    const objectcd = this.store.selectSnapshot(AuthSelectors.objectcd);
    return this.store.dispatch(new SetStaffList(objectcd)).pipe(
      map(() => { return this.store.selectSnapshot(DataSelectors.staffList(objectcd)) }),
      mergeMap((res) => (res ? of(res) : EMPTY))
    );
  }
}
